import accountSafe from './pl/account-safe'
import affiliate from './pl/affiliate'
import bankTransfer from './pl/bankTransfer'
import cart from './pl/cart'
import cartAndWarehouse from './pl/cartAndWarehouse'
import common from './pl/common'
import consult from './pl/consult'
import debt from './pl/debt'
import distribution from './pl/distribution'
import estimation from './pl/estimation'
import form from './pl/form'
import home from './pl/home'
import kol from './pl/kol'
import order from './pl/order'
import orderDetail from './pl/orderDetail'
import packages from './pl/package'
import pay from './pl/pay'
import pecenter from './pl/pecenter'
import points from './pl/points'
import previewPackage from './pl/previewPackage.json'
import previewPackageOptimize from './pl/previewPackageOptimize'
import product from './pl/product'
import returnChange from './pl/returnChange'
import search from './pl/search'
import shareCoupon from './pl/shareCoupon'
import sharePackage from './pl/sharePackage'
import shoppingGuide from './pl/shoppingGuide'
import site from './pl/site'
import status from './pl/status'
import storage from './pl/storage'
import tag from './pl/tag'
import tips from './pl/tips'
import transport from './pl/transport'
import uniOrder from './pl/uniOrder'
import vip from './pl/vip'
import warnTips from './pl/warnTips'
export default {
  'account-safe': accountSafe,
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  distribution,
  uniOrder,
  bankTransfer,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
  vip,
}
